export default {
  name: 'wp_editor',
  props: {
    editor_id: {
      type: String,
      "default": function _default() {
        return 'wp_editor_' + Date.now() + parseInt(Math.random() * 1000);
      }
    },
    modelValue: {
      type: String,
      "default": function _default() {
        return '';
      }
    },
    editorShortcodes: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    height: {
      type: Number,
      "default": function _default() {
        return 250;
      }
    },
    mediaButtons: {
      type: Boolean,
      "default": function _default() {
        return true;
      }
    },
    autofocus: {
      type: Boolean,
      "default": function _default() {
        return false;
      }
    }
  },
  emits: ['update:modelValue'],
  data: function data() {
    return {
      showButtonDesigner: false,
      hasWpEditor: !!window.wp.editor && !!wp.editor.autop || !!window.wp.oldEditor,
      editor: window.wp.oldEditor || window.wp.editor,
      plain_content: this.modelValue,
      cursorPos: this.modelValue ? this.modelValue.length : 0,
      app_ready: false,
      buttonInitiated: false,
      currentEditor: false
    };
  },
  watch: {
    plain_content: function plain_content() {
      this.$emit('update:modelValue', this.plain_content);
    }
  },
  methods: {
    initEditor: function initEditor() {
      if (!this.hasWpEditor) {
        return;
      }
      this.editor.remove(this.editor_id);
      var that = this;
      var mceConfig = {
        height: that.height,
        toolbar1: 'formatselect,code,table,bold,italic,bullist,numlist,link,blockquote,alignleft,aligncenter,alignright,underline,strikethrough,forecolor,removeformat,codeformat,outdent,indent,undo,redo',
        setup: function setup(editor) {
          editor.on('change', function (ed, l) {
            that.changeContentEvent();
          });
        }
      };
      if (this.autofocus) {
        mceConfig.auto_focus = this.editor_id;
      }
      this.editor.initialize(this.editor_id, {
        mediaButtons: this.mediaButtons,
        tinymce: mceConfig,
        quicktags: true
      });
      jQuery('#' + this.editor_id).on('change', function (e) {
        that.changeContentEvent();
      });
    },
    insertHtml: function insertHtml(content) {
      this.currentEditor.insertContent(content);
    },
    changeContentEvent: function changeContentEvent() {
      var content = this.editor.getContent(this.editor_id);
      this.$emit('update:modelValue', content);
    },
    handleCommand: function handleCommand(command) {
      if (this.hasWpEditor) {
        window.tinymce.activeEditor.insertContent(command);
      } else {
        var part1 = this.plain_content.slice(0, this.cursorPos);
        var part2 = this.plain_content.slice(this.cursorPos, this.plain_content.length);
        this.plain_content = part1 + command + part2;
        this.cursorPos += command.length;
      }
    },
    updateCursorPos: function updateCursorPos() {
      var cursorPos = jQuery('.wp_vue_editor_plain').prop('selectionStart');
      this.cursorPos = cursorPos;
    }
  },
  mounted: function mounted() {
    this.initEditor();
    this.app_ready = true;
  }
};